import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {PlatformLocation} from '@angular/common';
import {unescapeIdentifier} from '@angular/compiler';
@Injectable()
export class CommonService {

  apiService: ApiService;

  constructor(
    apiService: ApiService,
    private platformLocation: PlatformLocation
  ) {
    this.apiService = apiService;
  }

   pinpointCourses = [
    {
      "id": 5001,
      "name": "纠正不良工作习惯",
      "version": "微课",
      "name_en": "Addressing Poor Work Habits ",
      "series": NaN,
      "library_id": "OMC0003,OMC0003EN"
    },
    {
      "id": 5002,
      "name": "真诚和透明度",
      "version": "微课",
      "name_en": "Authenticity and Transparency",
      "series": NaN,
      "library_id": "OMC0004,OMC0004EN"
    },
    {
      "id": 5003,
      "name": "培养商业洞见",
      "version": "微课",
      "name_en": "Being Business Savvy",
      "series": NaN,
      "library_id": "OMC0005,OMC0005EN"
    },
    {
      "id": 5004,
      "name": "为有效处理客户投诉做好准备",
      "version": "微课",
      "name_en": "Being Prepared to Take the HEAT",
      "series": NaN,
      "library_id": "OMC0006,OMC0006EN"
    },
    {
      "id": 5005,
      "name": "增强你的复原力",
      "version": "微课",
      "name_en": "Boost Your Resilience ",
      "series": NaN,
      "library_id": "OMC0007,OMC0007EN"
    },
    {
      "id": 5006,
      "name": "建立包容性文化",
      "version": "微课",
      "name_en": "Building an Inclusive Culture",
      "series": NaN,
      "library_id": "OMC0008,OMC0008EN"
    },
    {
      "id": 5007,
      "name": "在组织内外建立伙伴关系",
      "version": "微课",
      "name_en": "Building Partnerships Inside and Outside Your Organization",
      "series": NaN,
      "library_id": "OMC0009,OMC0009EN"
    },
    {
      "id": 5008,
      "name": "在虚拟环境中建立友好关系",
      "version": "微课",
      "name_en": "Building Rapport Virtually ",
      "series": NaN,
      "library_id": "OMC0010,OMC0010EN"
    },
    {
      "id": 5009,
      "name": "在你的工作环境中建立信任",
      "version": "微课",
      "name_en": "Building Trust in Your Work Environment",
      "series": NaN,
      "library_id": "OMC0011,OMC0011EN"
    },
    {
      "id": 5010,
      "name": "建立振奋人心的伙伴关系",
      "version": "微课",
      "name_en": "Building Uplifting Partnerships",
      "series": NaN,
      "library_id": "OMC0012,OMC0012EN"
    },
    {
      "id": 5011,
      "name": "职业辅导对话",
      "version": "微课",
      "name_en": "Career Coaching Conversations",
      "series": NaN,
      "library_id": "OMC0013,OMC0013EN"
    },
    {
      "id": 5012,
      "name": "职业生涯连接点",
      "version": "微课",
      "name_en": "Career Connection Points",
      "series": NaN,
      "library_id": "OMC0014,OMC0014EN"
    },
    {
      "id": 5013,
      "name": "辅导挑战：辅导者的建议",
      "version": "微课",
      "name_en": "Coaching Challenges Tips From a Coach",
      "series": NaN,
      "library_id": "OMC0015,OMC0015EN"
    },
    {
      "id": 5014,
      "name": "有效沟通以提升你的领导力品牌形象",
      "version": "微课",
      "name_en": "Communicating Effectively to Improve Leadership Brand ",
      "series": NaN,
      "library_id": "OMC0016,OMC0016EN"
    },
    {
      "id": 5015,
      "name": "在线沟通",
      "version": "微课",
      "name_en": "Communicating Virtually",
      "series": NaN,
      "library_id": "OMC0017,OMC0017EN"
    },
    {
      "id": 5016,
      "name": "促进包容性文化",
      "version": "微课",
      "name_en": "Contributing to an Inclusive Culture",
      "series": NaN,
      "library_id": "OMC0018,OMC0018EN"
    },
    {
      "id": 5017,
      "name": "勇敢坦率地开展谈话",
      "version": "微课",
      "name_en": "Conversations with Courage and Candor",
      "series": NaN,
      "library_id": "OMC0019,OMC0019EN"
    },
    {
      "id": 5018,
      "name": "在团队中创造辅导文化",
      "version": "微课",
      "name_en": "Creating a Coaching Culture on Your Team ",
      "series": NaN,
      "library_id": "OMC0020,OMC0020EN"
    },
    {
      "id": 5019,
      "name": "数据驱动型决策",
      "version": "微课",
      "name_en": "Data-Driven Decision Making ",
      "series": NaN,
      "library_id": "OMC0021,OMC0021EN"
    },
    {
      "id": 5020,
      "name": "发展各个团队成员",
      "version": "微课",
      "name_en": "Developing Individual Team Members",
      "series": NaN,
      "library_id": "OMC0022,OMC0022EN"
    },
    {
      "id": 5021,
      "name": "发现自己的辅导者特质",
      "version": "微课",
      "name_en": "Discover Your Unique Coach Qualities ",
      "series": NaN,
      "library_id": "OMC0023,OMC0023EN"
    },
    {
      "id": 5022,
      "name": "结果导向",
      "version": "微课",
      "name_en": "Driving for Results",
      "series": NaN,
      "library_id": "OMC0024,OMC0024EN"
    },
    {
      "id": 5023,
      "name": "拥抱变革：自我及他人",
      "version": "微课",
      "name_en": "Embracing Change: Yourself & Others",
      "series": NaN,
      "library_id": "OMC0025,OMC0025EN"
    },
    {
      "id": 5024,
      "name": "激励躺平摆烂者",
      "version": "微课",
      "name_en": "Engaging Quiet Quitters",
      "series": NaN,
      "library_id": "OMC0035,OMC0035EN"
    },
    {
      "id": 5025,
      "name": "确保防止团队倦怠",
      "version": "微课",
      "name_en": "Ensuring Your Team Avoids Burnout ",
      "series": NaN,
      "library_id": "OMC0026,OMC0026EN"
    },
    {
      "id": 5026,
      "name": "日常激励员工的小秘诀",
      "version": "微课",
      "name_en": "EveryDay Engagers ",
      "series": NaN,
      "library_id": "OMC0027,OMC0027EN"
    },
    {
      "id": 5027,
      "name": "反馈技巧体验",
      "version": "微课",
      "name_en": "Feedback Skills Experience",
      "series": NaN,
      "library_id": "SP0001,SP0001EN"
    },
    {
      "id": 5028,
      "name": "在多元文化团队中找到平衡",
      "version": "微课",
      "name_en": "Finding Balance Within a Multicultural Team",
      "series": NaN,
      "library_id": "OMC0029,OMC0029EN"
    },
    {
      "id": 5029,
      "name": "变革期间找到能够掌控的领域",
      "version": "微课",
      "name_en": "Finding Control During Change ",
      "series": NaN,
      "library_id": "OMC0030,OMC0030EN"
    },
    {
      "id": 5030,
      "name": "作为新领导者获得发展势头 ",
      "version": "微课",
      "name_en": "Gaining Momentum as a New Leader",
      "series": NaN,
      "library_id": "OMC0031,OMC0031EN"
    },
    {
      "id": 5031,
      "name": "改进型反馈",
      "version": "微课",
      "name_en": "Giving Feedback For Improvement",
      "series": NaN,
      "library_id": "OMC0032,OMC0032EN"
    },
    {
      "id": 5032,
      "name": "提供正面反馈",
      "version": "微课",
      "name_en": "Giving Positive Feedback",
      "series": NaN,
      "library_id": "OMC0033,OMC0033EN"
    },
    {
      "id": 5033,
      "name": "处理情绪和烦恼",
      "version": "微课",
      "name_en": "Handling Emotion and Upset ",
      "series": NaN,
      "library_id": "OMC0034,OMC0034EN"
    },
    {
      "id": 5034,
      "name": "影响他人使事情成功 ",
      "version": "微课",
      "name_en": "Influencing Others to Make Things Happen",
      "series": NaN,
      "library_id": "OSC0020,OSC0020EN"
    },
    {
      "id": 5035,
      "name": "互动技巧挑战",
      "version": "微课",
      "name_en": "Interaction Skills Challenge ",
      "series": NaN,
      "library_id": "OMC0036,OMC0036EN"
    },
    {
      "id": 5036,
      "name": "互动技巧体验",
      "version": "微课",
      "name_en": "Interaction Skills Experience",
      "series": NaN,
      "library_id": "SP0002,SP0002EN"
    },
    {
      "id": 5037,
      "name": "领导高绩效团队",
      "version": "微课",
      "name_en": "Leading a High Performance Team",
      "series": NaN,
      "library_id": "OMC0038,OMC0038EN"
    },
    {
      "id": 5038,
      "name": "领导混合团队",
      "version": "微课",
      "name_en": "Leading Hybrid Teams",
      "series": NaN,
      "library_id": "OMC0039,OMC0039EN"
    },
    {
      "id": 5039,
      "name": "领导虚拟团队",
      "version": "微课",
      "name_en": "Leading Teams Virtually",
      "series": NaN,
      "library_id": "OMC0040,OMC0040EN"
    },
    {
      "id": 5040,
      "name": "主持在线会议",
      "version": "微课",
      "name_en": "Leading Virtual Meetings ",
      "series": NaN,
      "library_id": "OMC0041,OMC0041EN"
    },
    {
      "id": 5041,
      "name": "敢于放手，增加放权",
      "version": "微课",
      "name_en": "Letting Go and Delegating More",
      "series": NaN,
      "library_id": "OMC0042,OMC0042EN"
    },
    {
      "id": 5042,
      "name": "利用多样性",
      "version": "微课",
      "name_en": "Leveraging Diversity",
      "series": NaN,
      "library_id": "OMC0043,OMC0043EN"
    },
    {
      "id": 5043,
      "name": "快速制定决策",
      "version": "微课",
      "name_en": "Making Accelerated Decisions",
      "series": NaN,
      "library_id": "OMC0044,OMC0044EN"
    },
    {
      "id": 5044,
      "name": "管理多代团队",
      "version": "微课",
      "name_en": "Managing a Multigenerational Team",
      "series": NaN,
      "library_id": "OMC0045,OMC0045EN"
    },
    {
      "id": 5045,
      "name": "管理风险的人性要素",
      "version": "微课",
      "name_en": "Managing the People Side of Risk",
      "series": NaN,
      "library_id": "OMC0046,OMC0046EN"
    },
    {
      "id": 5046,
      "name": "职场欺凌管理",
      "version": "微课",
      "name_en": "Managing Workplace Bullying",
      "series": NaN,
      "library_id": "OMC0047,OMC0047EN"
    },
    {
      "id": 5047,
      "name": "继续下一场冒险：寻求新职位或职务",
      "version": "微课",
      "name_en": "On to the Next Adventure: Seeking a New Position or Role ",
      "series": NaN,
      "library_id": "OMC0048,OMC0048EN"
    },
    {
      "id": 5048,
      "name": "克服职业倦怠",
      "version": "微课",
      "name_en": "Overcoming Your Workplace Burnout",
      "series": NaN,
      "library_id": "OMC0049,OMC0049EN"
    },
    {
      "id": 5049,
      "name": "小组面试",
      "version": "微课",
      "name_en": "Panel Interviewing",
      "series": NaN,
      "library_id": "OMC0001,OMC0001EN"
    },
    {
      "id": 5050,
      "name": "同侪辅导要点",
      "version": "微课",
      "name_en": "Peer Coaching Essentials",
      "series": NaN,
      "library_id": "OMC0050,OMC0050EN"
    },
    {
      "id": 5051,
      "name": "为高难度谈话做准备",
      "version": "微课",
      "name_en": "Preparing for Difficult Conversations ",
      "series": NaN,
      "library_id": "OMC0002,OMC0002EN"
    },
    {
      "id": 5052,
      "name": "确定优先级和工作效率",
      "version": "微课",
      "name_en": "Prioritizing and Productivity",
      "series": NaN,
      "library_id": "OMC0051,OMC0051EN"
    },
    {
      "id": 5053,
      "name": "有目的性地建立人脉",
      "version": "微课",
      "name_en": "Purposeful Networking",
      "series": NaN,
      "library_id": "OMC0052,OMC0052EN"
    },
    {
      "id": 5054,
      "name": "解决你面临的冲突",
      "version": "微课",
      "name_en": "Resolving a Conflict You’re Involved In",
      "series": NaN,
      "library_id": "OMC0053,OMC0053EN"
    },
    {
      "id": 5055,
      "name": "留才驱动因子",
      "version": "微课",
      "name_en": "Retention Drivers",
      "series": NaN,
      "library_id": "OMC0054,OMC0054EN"
    },
    {
      "id": 5056,
      "name": "设定SMART 目标以管理绩效",
      "version": "微课",
      "name_en": "Setting SMART Goals to Manage Performance",
      "series": NaN,
      "library_id": "OMC0055,OMC0055EN"
    },
    {
      "id": 5057,
      "name": "激发创新文化",
      "version": "微课",
      "name_en": "Sparking a Culture of Innovation",
      "series": NaN,
      "library_id": "OMC0056,OMC0056EN"
    },
    {
      "id": 5058,
      "name": "站会和例会：解决团队挑战的简短会议",
      "version": "微课",
      "name_en": "Stand and Huddle: Short Meetings that Address Team Challenges",
      "series": NaN,
      "library_id": "OMC0057,OMC0057EN"
    },
    {
      "id": 5059,
      "name": "成功起步",
      "version": "微课",
      "name_en": "Starting Strong",
      "series": NaN,
      "library_id": "OMC0058,OMC0058EN"
    },
    {
      "id": 5060,
      "name": "用数据讲故事",
      "version": "微课",
      "name_en": "Storytelling with Data",
      "series": NaN,
      "library_id": "OMC0059,OMC0059EN"
    },
    {
      "id": 5061,
      "name": "询问的力量",
      "version": "微课",
      "name_en": "The Power of Seeking",
      "series": NaN,
      "library_id": "OMC0060,OMC0060EN"
    },
    {
      "id": 5062,
      "name": "无意识偏见：知行合一",
      "version": "微课",
      "name_en": "Unconscious Bias: Awareness into Action",
      "series": NaN,
      "library_id": "OMC0061,OMC0061EN"
    },
    {
      "id": 5063,
      "name": "工作幸福感",
      "version": "微课",
      "name_en": "Wellbeing at Work",
      "series": NaN,
      "library_id": "OMC0028,OMC0028EN"
    },
    {
      "id": 5064,
      "name": "雷达分析图概览",
      "version": "微课",
      "name_en": "What’s on Your Radar?",
      "series": NaN,
      "library_id": "OMC0037,OMC0037EN"
    },
    {
      "id": 5065,
      "name": "辅导：引领前行",
      "version": "在线课",
      "name_en": "Coaching: Move People Forward",
      "series": NaN,
      "library_id": "OSC0003,OSC0003EN"
    },
    {
      "id": 5066,
      "name": "处理不良绩效",
      "version": "在线课",
      "name_en": "Addressing Poor Performance",
      "series": NaN,
      "library_id": "OSC0001,OSC0001EN"
    },
    {
      "id": 5067,
      "name": "建立并维护信任",
      "version": "在线课",
      "name_en": "Building and Sustaining Trust",
      "series": NaN,
      "library_id": "OSC0002,OSC0002EN"
    },
    {
      "id": 5068,
      "name": "有影响力的沟通",
      "version": "在线课",
      "name_en": "Communicating with Impact ",
      "series": NaN,
      "library_id": "OSC0004,OSC0004EN"
    },
    {
      "id": 5069,
      "name": "沟通：互动联结",
      "version": "在线课",
      "name_en": "Communication: Connect Through Conversations",
      "series": NaN,
      "library_id": "OSC0005,OSC0005EN"
    },
    {
      "id": 5070,
      "name": "授权：鼓励参与，授权委责",
      "version": "在线课",
      "name_en": "Delegation: Engage and Empower People",
      "series": NaN,
      "library_id": "OSC0006,OSC0006EN"
    },
    {
      "id": 5071,
      "name": "发展自我及他人",
      "version": "在线课",
      "name_en": "Developing Yourself and Others ",
      "series": NaN,
      "library_id": "OSC0007,OSC0007EN"
    },
    {
      "id": 5072,
      "name": "驱动变革",
      "version": "在线课",
      "name_en": "Driving Change",
      "series": NaN,
      "library_id": "OSC0008,OSC0008EN"
    },
    {
      "id": 5073,
      "name": "激励部属，留住人才",
      "version": "在线课",
      "name_en": "Engaging and Retaining Talent ",
      "series": NaN,
      "library_id": "OSC0009,OSC0009EN"
    },
    {
      "id": 5074,
      "name": "有影响力的反馈和聆听",
      "version": "在线课",
      "name_en": "High-Impact Feedback and Listening",
      "series": NaN,
      "library_id": "OSC0010,OSC0010EN"
    },
    {
      "id": 5075,
      "name": "高质量决策",
      "version": "在线课",
      "name_en": "Making High-Quality Decisions ",
      "series": NaN,
      "library_id": "OSC0011,OSC0011EN"
    },
    {
      "id": 5076,
      "name": "充分发挥影响力技能",
      "version": "在线课",
      "name_en": "Maximizing the Power Skills",
      "series": NaN,
      "library_id": "OSC0012,OSC0012EN"
    },
    {
      "id": 5077,
      "name": "解决工作冲突",
      "version": "在线课",
      "name_en": "Resolving Workplace Conflict",
      "series": NaN,
      "library_id": "OSC0013,OSC0013EN"
    },
    {
      "id": 5078,
      "name": "培养战略领导力的6个步骤",
      "version": "在线课",
      "name_en": "Six Steps to Strategic Leadership",
      "series": NaN,
      "library_id": "OSC0015,OSC0015EN"
    },
    {
      "id": 5079,
      "name": "实现优质服务的步骤",
      "version": "在线课",
      "name_en": "Steps for Great Service",
      "series": NaN,
      "library_id": "OSC0016,OSC0016EN"
    },
    {
      "id": 5080,
      "name": "迈向领导之路",
      "version": "在线课",
      "name_en": "Your Leadership Journey",
      "series": NaN,
      "library_id": "OSC0019,OSC0019EN"
    },
    {
      "id": 5081,
      "name": "目标选才：行为面试的艺术",
      "version": "在线课",
      "name_en": "The Art of Behavioral Interviewing ",
      "series": NaN,
      "library_id": "OSC0017,OSC0017EN"
    },
    {
      "id": 5082,
      "name": "目标选才：行为面试的科学",
      "version": "在线课",
      "name_en": "The Science of Behavioral Interviewing",
      "series": NaN,
      "library_id": "OSC0018,OSC0018EN"
    },
    {
      "id": 5083,
      "name": "设定目标，复核绩效",
      "version": "在线课",
      "name_en": "Setting Goals and Reviewing Results",
      "series": NaN,
      "library_id": "OSC0014,OSC0014EN"
    },
    {
      "id": 5084,
      "name": "辅导全人",
      "version": "微课",
      "name_en": "Coaching the Whole Person",
      "series": NaN,
      "library_id": "OMC0105,OMC0105EN"
    },
    {
      "id": 5085,
      "name": "推动职业发展",
      "version": "微课",
      "name_en": "Driving Career Development",
      "series": NaN,
      "library_id": "OMC0106,OMC0106EN"
    },
    {
      "id": 5086,
      "name": "以积极意图推动文化发展",
      "version": "微课",
      "name_en": "Driving Culture with Intent",
      "series": NaN,
      "library_id": "OMC0107,OMC0107EN"
    },
    {
      "id": 5087,
      "name": "增强团队解决冲突的能力",
      "version": "微课",
      "name_en": "Empowering Teams to Resolve Conflict",
      "series": NaN,
      "library_id": "OMC0108,OMC0108EN"
    },
    {
      "id": 5088,
      "name": "包容性辅导者入门",
      "version": "微课",
      "name_en": "Getting Started as an Inclusive Coach",
      "series": NaN,
      "library_id": "OMC0109,OMC0109EN"
    },
    {
      "id": 5089,
      "name": "以人为本的领导力",
      "version": "微课",
      "name_en": "Human-Centered Leadership",
      "series": NaN,
      "library_id": "OMC0110,OMC0110EN"
    },
    {
      "id": 5090,
      "name": "在颠覆性变化期间维护信任",
      "version": "微课",
      "name_en": "Sustaining Trust During Disruptive Change",
      "series": NaN,
      "library_id": "OMC0112,OMC0112EN"
    },
    {
      "id": 5091,
      "name": "摆脱新晋领导者冒名顶替综合症",
      "version": "微课",
      "name_en": "Taking Control of New Leader Imposter Syndrome",
      "series": NaN,
      "library_id": "OMC0113,OMC0113EN"
    },
    {
      "id": 5092,
      "name": "预测变化，灵活应对",
      "version": "微课",
      "name_en": "Anticipate Change with Agility",
      "series": NaN,
      "library_id": "OMC0114,OMC0114EN"
    },
    {
      "id": 5093,
      "name": "晋升和管理冒充者综合征",
      "version": "微课",
      "name_en": "Moving Up and Managing Imposter Syndrome",
      "series": NaN,
      "library_id": "OMC0115,OMC0115EN"
    },
    {
      "id": 5094,
      "name": "驾驭组织政治",
      "version": "微课",
      "name_en": "Navigating Organizational Politics",
      "series": NaN,
      "library_id": "OMC0116,OMC0116EN"
    },
    {
      "id": 5095,
      "name": "制定有目的性的决策",
      "version": "微课",
      "name_en": "Making Intentional Decisions",
      "series": NaN,
      "library_id": "OMC0117,OMC0117EN"
    },
    {
      "id": 5096,
      "name": "在危机时期进行自我领导",
      "version": "在线课",
      "name_en": "Leading Self in Times of Crisis",
      "series": NaN,
      "library_id": "OSC0041,OSC0041EN"
    },
    {
      "id": 5097,
      "name": "掌控高管互动",
      "version": "在线课",
      "name_en": "Mastering Executive Interactions",
      "series": NaN,
      "library_id": "OSC0042,OSC0042EN"
    },
    {
      "id": 5501,
      "name": "达至最佳绩效",
      "version": "英跃微课",
      "name_en": "Maximizing Performance",
      "series": NaN,
      "library_id": "OSC0023V"
    },
    {
      "id": 5502,
      "name": "打造高效团队",
      "version": "英跃微课",
      "name_en": "Guiding Team success",
      "series": NaN,
      "library_id": "OSC0029V"
    },
    {
      "id": 5503,
      "name": "辅导",
      "version": "英跃微课",
      "name_en": "Coaching",
      "series": NaN,
      "library_id": "OSC0025V"
    },
    {
      "id": 5504,
      "name": "激励与保留人才",
      "version": "英跃微课",
      "name_en": "Engaging and Retaining Talent",
      "series": NaN,
      "library_id": "OSC0026V"
    },
    {
      "id": 5505,
      "name": "计划与组织",
      "version": "英跃微课",
      "name_en": "Planning and Organizing",
      "series": NaN,
      "library_id": "OSC0035V"
    },
    {
      "id": 5506,
      "name": "解决冲突",
      "version": "英跃微课",
      "name_en": "Resolving Conflict",
      "series": NaN,
      "library_id": "OSC0033V"
    },
    {
      "id": 5507,
      "name": "决策",
      "version": "英跃微课",
      "name_en": "Decision Making",
      "series": NaN,
      "library_id": "OSC0036V"
    },
    {
      "id": 5508,
      "name": "领导力精要",
      "version": "英跃微课",
      "name_en": "Communicating for Leadership Success ",
      "series": NaN,
      "library_id": "OSC0021V"
    },
    {
      "id": 5509,
      "name": "领导虚拟团队",
      "version": "英跃微课",
      "name_en": "Leading Virtual Team",
      "series": NaN,
      "library_id": "OSC0037V"
    },
    {
      "id": 5510,
      "name": "目标选才",
      "version": "英跃微课",
      "name_en": "Targeted Selection",
      "series": NaN,
      "library_id": "OSC0038V"
    },
    {
      "id": 5511,
      "name": "培养人才",
      "version": "英跃微课",
      "name_en": "Building Talent",
      "series": NaN,
      "library_id": "OSC0022V"
    },
    {
      "id": 5512,
      "name": "驱动变革",
      "version": "英跃微课",
      "name_en": "Driving Change",
      "series": NaN,
      "library_id": "OSC0024V"
    },
    {
      "id": 5513,
      "name": "授权",
      "version": "英跃微课",
      "name_en": "Delegating",
      "series": NaN,
      "library_id": "OSC0027V"
    },
    {
      "id": 5514,
      "name": "推动创新",
      "version": "英跃微课",
      "name_en": "Driving Innovation",
      "series": NaN,
      "library_id": "OSC0028V"
    },
    {
      "id": 5515,
      "name": "协作",
      "version": "英跃微课",
      "name_en": "Building Partnership",
      "series": NaN,
      "library_id": "OSC0032V"
    },
    {
      "id": 5516,
      "name": "影响力",
      "version": "英跃微课",
      "name_en": "Influencing",
      "series": NaN,
      "library_id": "OSC0034V"
    },
    {
      "id": 5517,
      "name": "执行力",
      "version": "英跃微课",
      "name_en": "Execution",
      "series": NaN,
      "library_id": "OSC0030V"
    },
    {
      "id": 5601,
      "name": "如何避免鸡同鸭讲的悲剧",
      "version": "酷领导",
      "name_en": "How to avoid the tragic misalignment in communication? ",
      "series": "超效沟通",
      "library_id": "OMC0068"
    },
    {
      "id": 5602,
      "name": "如何处理气氛紧张的谈话",
      "version": "酷领导",
      "name_en": "How to deal with tensioned conversations? ",
      "series": "超效沟通",
      "library_id": "OMC0069"
    },
    {
      "id": 5603,
      "name": "如何通过提问来发掘真相",
      "version": "酷领导",
      "name_en": "How to tap into truth through asking questions? ",
      "series": "超效沟通",
      "library_id": "OMC0070"
    },
    {
      "id": 5604,
      "name": "如何把话说到别人心里去",
      "version": "酷领导",
      "name_en": "How to have a heart-to-heart talk? ",
      "series": "超效沟通",
      "library_id": "OMC0071"
    },
    {
      "id": 5605,
      "name": "如何开启一次困难的谈话",
      "version": "酷领导",
      "name_en": "How to initiate a difficult conversation?",
      "series": "超效沟通",
      "library_id": "OMC0072"
    },
    {
      "id": 5606,
      "name": "如何有效总结一次谈话",
      "version": "酷领导",
      "name_en": "How to effectively summarize a conversation? ",
      "series": "超效沟通",
      "library_id": "OMC0073"
    },
    {
      "id": 5607,
      "name": "辅导真的有用么",
      "version": "酷领导",
      "name_en": "Does coaching really work? ",
      "series": "卓越辅导",
      "library_id": "OMC0084"
    },
    {
      "id": 5608,
      "name": "辅导如何打中要害",
      "version": "酷领导",
      "name_en": "How to hit the bullseye in coaching? ",
      "series": "卓越辅导",
      "library_id": "OMC0085"
    },
    {
      "id": 5609,
      "name": "辅导中如何提高员工对方案的认可度",
      "version": "酷领导",
      "name_en": "How to improve employees’ recognition towards the proposal? ",
      "series": "卓越辅导",
      "library_id": "OMC0086"
    },
    {
      "id": 5610,
      "name": "如何给员工有效的反馈",
      "version": "酷领导",
      "name_en": "How to provide employees with effective feedbacks? ",
      "series": "卓越辅导",
      "library_id": "OMC0087"
    },
    {
      "id": 5611,
      "name": "插件：STAR法则",
      "version": "酷领导",
      "name_en": "*STAR",
      "series": "卓越辅导",
      "library_id": "OMC0088"
    },
    {
      "id": 5612,
      "name": "如何建立高效团队",
      "version": "酷领导",
      "name_en": "How to build a high-performance team?",
      "series": "建立超卓团队",
      "library_id": "OMC0074"
    },
    {
      "id": 5613,
      "name": "建立团队的第一步是什么",
      "version": "酷领导",
      "name_en": "What is the first step in team building? ",
      "series": "建立超卓团队",
      "library_id": "OMC0075"
    },
    {
      "id": 5614,
      "name": "如何使团队达标（上）",
      "version": "酷领导",
      "name_en": "How to make your team achieve its goals (part 1)? ",
      "series": "建立超卓团队",
      "library_id": "OMC0076"
    },
    {
      "id": 5615,
      "name": "如何使团队达标（下）",
      "version": "酷领导",
      "name_en": "How to make your team achieve its goals (part 2)?",
      "series": "建立超卓团队",
      "library_id": "OMC0077"
    },
    {
      "id": 5616,
      "name": "如何促进团队沟通与信任",
      "version": "酷领导",
      "name_en": "How to promote team communication and trust? ",
      "series": "建立超卓团队",
      "library_id": "OMC0078"
    },
    {
      "id": 5617,
      "name": "决策你不可不知的事",
      "version": "酷领导",
      "name_en": "Things you must know about decision-making ",
      "series": "效率决策",
      "library_id": "OMC0079"
    },
    {
      "id": 5618,
      "name": "做决定的第一步是什么",
      "version": "酷领导",
      "name_en": "What is the first step to make a decision? ",
      "series": "效率决策",
      "library_id": "OMC0080"
    },
    {
      "id": 5619,
      "name": "为何收集这么多信息决策还错了 ",
      "version": "酷领导",
      "name_en": "Why the decision is still wrong after so much information has been collected? ",
      "series": "效率决策",
      "library_id": "OMC0081"
    },
    {
      "id": 5620,
      "name": "如何跳出非黑即白的决策困境",
      "version": "酷领导",
      "name_en": "How to jump out of the black-and-white dilemma in decision-making? ",
      "series": "效率决策",
      "library_id": "OMC0082"
    },
    {
      "id": 5621,
      "name": "决策方案，你还在纠结哪个好吗",
      "version": "酷领导",
      "name_en": "Are you still struggling with which decision alternative is better?",
      "series": "效率决策",
      "library_id": "OMC0083"
    },
    {
      "id": 5622,
      "name": "做领导者，你准备好了没",
      "version": "酷领导",
      "name_en": "You are a leader now, are you ready for this role? ",
      "series": "开启领导力之门",
      "library_id": "OMC0064"
    },
    {
      "id": 5623,
      "name": "新任主管如何摆脱迷茫",
      "version": "酷领导",
      "name_en": "How could a new manager overcome their confusion? ",
      "series": "开启领导力之门",
      "library_id": "OMC0065"
    },
    {
      "id": 5624,
      "name": "新任领导如何避免遗忘团队管理",
      "version": "酷领导",
      "name_en": "How could new leaders avoid neglecting team management? ",
      "series": "开启领导力之门",
      "library_id": "OMC0066"
    },
    {
      "id": 5625,
      "name": "为什么用人育人总使不对劲",
      "version": "酷领导",
      "name_en": "Why efforts in talent development and cultivation always end up being ineffective? ",
      "series": "开启领导力之门",
      "library_id": "OMC0067"
    },
    {
      "id": 5626,
      "name": "如何带领员工接受改变",
      "version": "酷领导",
      "name_en": "How to lead employees to accept change? ",
      "series": "活化变革",
      "library_id": "OMC0097"
    },
    {
      "id": 5627,
      "name": "变革来临了如何与员工沟通",
      "version": "酷领导",
      "name_en": "In the face of the upcoming change, how to communicate with employees? ",
      "series": "活化变革",
      "library_id": "OMC0098"
    },
    {
      "id": 5628,
      "name": "如何让员工成为推动变革的主人翁",
      "version": "酷领导",
      "name_en": "How to drive employees to take ownership in facilitating change? ",
      "series": "活化变革",
      "library_id": "OMC0099"
    },
    {
      "id": 5629,
      "name": "变革中，员工总是犹豫不前怎么办",
      "version": "酷领导",
      "name_en": "What to do if employees always stagnate in change? ",
      "series": "活化变革",
      "library_id": "OMC0100"
    },
    {
      "id": 5630,
      "name": "如何让绩效管理不只是文书工作",
      "version": "酷领导",
      "name_en": "How to transform performance management into something more than paperwork? ",
      "series": "巅峰绩效对话",
      "library_id": "OMC0093"
    },
    {
      "id": 5631,
      "name": "员工觉得目标太高了怎么办",
      "version": "酷领导",
      "name_en": "What to do if employees feel that the goals are unrealistically high? ",
      "series": "巅峰绩效对话",
      "library_id": "OMC0094"
    },
    {
      "id": 5632,
      "name": "如何客观地评估绩效",
      "version": "酷领导",
      "name_en": "How to objectively evaluate performance? ",
      "series": "巅峰绩效对话",
      "library_id": "OMC0095"
    },
    {
      "id": 5633,
      "name": "员工不认可绩效评分，该怎么办",
      "version": "酷领导",
      "name_en": "What to do if employees do not acknowledge scores of performance evaluation? ",
      "series": "巅峰绩效对话",
      "library_id": "OMC0096"
    },
    {
      "id": 5634,
      "name": "如何应对项目改变",
      "version": "酷领导",
      "name_en": "How to respond to project changes? ",
      "series": "任务规划与执行",
      "library_id": "OMC0089"
    },
    {
      "id": 5635,
      "name": "如何防止项目死在起跑线上",
      "version": "酷领导",
      "name_en": "How to prevent early termination of a project? ",
      "series": "任务规划与执行",
      "library_id": "OMC0090"
    },
    {
      "id": 5636,
      "name": "如何预估项目时间",
      "version": "酷领导",
      "name_en": "How to estimate project duration? ",
      "series": "任务规划与执行",
      "library_id": "OMC0091"
    },
    {
      "id": 5637,
      "name": "为什么下属总是交不出我想要的成果",
      "version": "酷领导",
      "name_en": "Why my direct reports always fail to deliver satisfactory results? ",
      "series": "任务规划与执行",
      "library_id": "OMC0092"
    },
    {
      "id": 5638,
      "name": "老板为何不要听我的汇报",
      "version": "酷领导",
      "name_en": "Why my boss doesn’t listen to my reporting? ",
      "series": "致胜表达",
      "library_id": "OMC0101"
    },
    {
      "id": 5639,
      "name": "如何不把工作汇报变成流水账",
      "version": "酷领导",
      "name_en": "Why you shouldn’t make work reporting a running account? ",
      "series": "致胜表达",
      "library_id": "OMC0102"
    },
    {
      "id": 5640,
      "name": "如何有条理地汇报",
      "version": "酷领导",
      "name_en": "How to report in a well organized fashion? ",
      "series": "致胜表达",
      "library_id": "OMC0103"
    },
    {
      "id": 5641,
      "name": "如何回应领导问题",
      "version": "酷领导",
      "name_en": "How to respond to leaders’ questions? ",
      "series": "致胜表达",
      "library_id": "OMC0104"
    }
  ]

  xorKey = 'a665a45920422f9d417e4867efdc4fb8a04a1f3fff1fa07e998e86f7f7a27ae3';

  /**
   * 根据课程ID获取对应的英文课程名称
   *
   * 该函数在预定义的pinpointCourses数组中查找与给定ID匹配的课程对象，
   * 并返回其英文名称。若未找到对应课程则返回null
   *
   * @param {string|number} id - 需要查询的课程唯一标识符
   * @returns {?string} 对应课程的英文名称，未找到时返回null
   */
  getPinpointCourseEnNameById = (id) => {
    // 在预定义课程数组中执行线性搜索
    const course = this.pinpointCourses.find(course => course.id === id);
    // 返回查询结果处理
    return course ? course.name_en : null;
  }

  /**
   * 获取基础字体大小
   * @returns number
   */
  getBaseFontSize = () => {
    const num = Math.min(window.innerWidth, window.innerHeight);
    console.log('新计算方式的num', num);
    return num / 7.5;
  }

  initPage(obj?: any){
    const html = document.documentElement;
    let htmlFontSize;
    
    htmlFontSize = this.getBaseFontSize();
    // if(window.frames.length != parent.frames.length){
    //   console.log('进入嵌套页面的根元素指定');
    //   if(window.innerWidth < window.innerHeight){
    //     htmlFontSize = window.innerWidth/ 7.5;
    //   }else{
    //     htmlFontSize = window.innerHeight/ 7.5;
    //   }
    // }else{
    //   console.log('进入非嵌套页面的根元素指定');
    //   if(window.screen.width < window.screen.height){
    //     htmlFontSize = window.screen.width/ 7.5;
    //   }else{
    //     htmlFontSize = window.screen.height/ 7.5;
    //   }
    // }

    html.style.fontSize = htmlFontSize + 'px';
    
    if (obj == undefined){
        html.style.backgroundImage = 'linear-gradient(180deg,#20327E,#434C9D)';
    }else{
        html.style.backgroundColor = obj.backgroundColor != undefined ? obj.backgroundColor : '#3f4c84';
        html.style.backgroundImage = obj.backgroundImage != undefined ? obj.backgroundImage : 'none';
    }
  }

  // wxSubscribe(){
  //   let data = {
  //     pageUrl: window.location.href.indexOf('#') !== -1 ? encodeURIComponent(window.location.href.split("#")[0]):encodeURIComponent(window.location.href),
  //   };
  //   this.apiService.getWechatConfig(data).subscribe((result) => {
  //     wx.config({
  //       debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //       appId: result.appId, //公众号的唯一标识
  //       timestamp: result.timestamp, //生成签名的时间戳
  //       nonceStr: result.nonceStr, //生成签名的随机串
  //       signature: result.signature, //签名
  //       jsApiList: [
  //         "onMenuShareAppMessage",
  //         "onMenuShareTimeline",
  //         "hideAllNonBaseMenuItem",
  //         "showAllNonBaseMenuItem",],
  //       openTagList: ['wx-open-subscribe']
  //     });
  //
  //     wx.ready(function () {
  //       wx.hideAllNonBaseMenuItem();
  //     });
  //   });
  // }

  wxSubscribe(data: any): Promise<any>{
    return this.apiService.getWechatConfig(data).toPromise();
  }

  handleFontSize(){
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    WeixinJSBridge.on('menu:setfont', function () {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
      WeixinJSBridge.call('hideToolbar');
    });
  }

  // base64编码
  base64Encode(str: string) {
    // 兼容 Unicode 的标准方案
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        (_, p1) => String.fromCharCode(parseInt(p1, 16)))
    );
  }

  // 登录账号密码加密：随机生成12位字母数字密钥，用于构建字符池
  private secretKey = this.generateSecretKey(12);
  private charPool = this.buildCharPool(this.secretKey);

  private generateSecretKey(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  private buildCharPool(key: string): string {
    let seed = 0;
    for (let i = 0; i < key.length; i++) {
      seed = ((seed << 5) - seed) + key.charCodeAt(i);
      seed |= 0;
    }

    const pool = [];
    let currentSeed = seed;
    for (let i = 0; i < 256; i++) {
      currentSeed = (currentSeed * 1103515245 + 12345) & 0x7fffffff;
      const rand = currentSeed / 0x7fffffff;

      const type = Math.floor(rand * 3);
      let charCode;
      if (type === 0) {
        charCode = 65 + Math.floor(rand * 26); // A-Z
      } else if (type === 1) {
        charCode = 97 + Math.floor(rand * 26); // a-z
      } else {
        charCode = 48 + Math.floor(rand * 10); // 0-9
      }
      pool.push(String.fromCharCode(charCode));
    }
    return pool.join('');
  }

  /**
   * 加密：在每个字符前插入3个伪装字符
   */
  encrypt(original: string): string {
    const result = [];
    for (let i = 0; i < original.length; i++) {
      const c = original[i];
      const idx = (i * c.charCodeAt(0)) % (this.charPool.length - 3);
      const fake = this.charPool.slice(idx, idx + 3);
      result.push(fake + c);
    }
    return result.join('');
  }

  /**
   * 解密：每4个字符取最后1个
   */
  decrypt(encrypted: string): string {
    const result = [];
    for (let i = 0; i < encrypted.length; i += 4) {
      result.push(encrypted[i + 3]);
    }
    return result.join('');
  }

  rootFontSize(){
    let htmlFontSize;
    if (window.frames.length != parent.frames.length){
      if (window.innerWidth < window.innerHeight){
        htmlFontSize = window.innerWidth / 7.5;
      }else{
        htmlFontSize = window.innerHeight / 7.5;
      }
    }else{
      if (window.screen.width < window.screen.height){
        htmlFontSize = window.screen.width / 7.5;
      }else{
        htmlFontSize = window.screen.height / 7.5;
      }
    }
    return htmlFontSize;
  }

  inArray(arr, value){
      for (let i = 0; i < arr.length; i++){
          if (value == arr[i]){
              return true;
          }
      }
      return false;
  }

  getIsSpecialLink(condition, href, tag, value){
    if (href.indexOf(condition) === -1){
      this.removeStorage(tag);
    }else{
      this.setStorage(tag, value);
    }
  }

  /**
   * 判断是否微信
   */
  isWeiXin(): boolean{
    const ua: any = window.navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == 'micromessenger';
  }

  /**
   * 判断是否企业微信
   */
  isWxWork(): boolean{
    const ua: any = window.navigator.userAgent.toLowerCase();
    return ua.match(/micromessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork';
  }

  getQueryString(name: string): any{
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const params = window.location.search.substr(1).match(reg);
    if (params != null) return unescapeIdentifier(params[2]); return null;
  }

  // 设置静态资源路径
  setAssetsRoute(assetsRoute){
    const target = document.getElementById('resource_route');
    return target.dataset.src === '' ? assetsRoute : target.dataset.src;
  }

  //设置学习断点
  addUserBreakPoint(postData: any): Promise<any>{
    return this.apiService.ajax({
      'type': 'POST',
      'url': 'sr/breakpoint/addLearningBreakpoint',
      'data': postData,
    }).toPromise();
  }


  //获取第一次值
  // 测、练、学、考-typeId-1、2、3、4
  // camp-introduce-typeId-7
  // camp-report-typeId-8
  // learningPath-typeId-9
  // 完成所有测学练考-typeId-10
  // 授权情景模拟视频、选人、选题、主体-type-id-701、702、703、704
  // 实战作业day14下载pdf短链接提示-typeId-14
  // 项目里有智能陪练第一次进入新手引导-typeId-15
  // AI导师新手引导-onceValue-100017
  // AI导师已访问（红点消除）-onceValue-100018
  MENTOR_GUIDE_ONCE_VALUE = 100017;
  MENTOR_ENTERED_ONCE_VALUE = 100018;
  // 进过导师的本地备份：避免跳转外链时 setOnceIno 被页面卸载打断，返回后红点仍在
  MENTOR_ENTERED_LOCAL_KEY = 'mentorEntered';

  isMentorGuideDebugMode(): boolean {
    return localStorage.getItem('admin') !== null;
  }

  private getMentorEnteredLocalKey(): string {
    const userId = localStorage.getItem('userId') || '';
    return userId ? `${this.MENTOR_ENTERED_LOCAL_KEY}_${userId}` : this.MENTOR_ENTERED_LOCAL_KEY;
  }

  markMentorEnteredLocal(): void {
    try {
      localStorage.setItem(this.getMentorEnteredLocalKey(), '1');
    } catch (e) {}
  }

  hasMentorEnteredLocal(): boolean {
    try {
      return localStorage.getItem(this.getMentorEnteredLocalKey()) === '1';
    } catch (e) {
      return false;
    }
  }

  clearMentorEnteredLocal(): void {
    try {
      localStorage.removeItem(this.getMentorEnteredLocalKey());
    } catch (e) {}
  }

  getOnceValue(learningPathMetaId, typeId){
    return Number(learningPathMetaId) * 1000 + Number(typeId);
  }

  //学习平台用户行为轨迹
  learningPortEventLog(data){
    return this.apiService.ajax({
      'type': 'POST',
      'url': 'sr/eventTracking/eventLog',
      // 'url': 'https://m-uat.transtalent.cn/sr/eventTracking/eventLog',
      'data': data,
    }).toPromise();
  }

  learningPortEventLogByCandy(data){
    return this.apiService.ajax({
      'type': 'POST',
      // 'url': 'https://m-dev.transtalent.cn/ddilearner/v1/user/event/click',
      // 'url': 'https://m-uat.transtalent.cn/ddilearner/v1/user/event/click',
      'url': 'ddilearner/v1/user/event/click',
      'data': data,
    }).toPromise();
  }

  sendPostMessage(type: any, key: string): void{
    window.parent.postMessage({
      [key]: type,
    }, '*');
  }

  sendDataMessage(name: string, nameVal: string, type: any, key: string): void{
    window.parent.postMessage({
      [name] : nameVal,
      [key]: type,
    }, '*');
  }

  // 获取是否第一次完成
  getOnceIno(onceValue){
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sr/onceino/' + onceValue,
    }).toPromise();
  }

  //根据learningPathMetaId获取课程名称
  // 0DNA 1辅导 2团队 11授权 12沟通 13组织 14协作 15影响力 16决策 18启程 20变革 22影响力增强 24MAX 26TS 28冲突 30影响力专业
  getCourseNameWithLearningPathMetaId(learningPathMetaId: number): string{
      return {
        1: '辅导',
        405: '辅导',
        605: '辅导',
        205: '辅导',
        305: '辅导',
        315: '辅导',
        325: '辅导',
        335: '辅导',
        11: '授权',
        403: '授权',
        15: '影响力',
        607: '影响力',
        307: '影响力',
        12: '领导力精要',
        202: '领导力精要',
        302: '领导力精要',
        312: '领导力精要',
        402: '领导力精要',
        24: '达至最佳绩效',
        406: '达至最佳绩效',
        606: '达至最佳绩效',
        2: '打造高效团队',
        13: '计划与组织',
        14: '协作',
        16: '决策',
        20: '驱动变革',
        309: '驱动变革',
        201: '目标选才',
        301: '目标选才',
        311: '目标选才',
        28: '解决冲突',
        208: '执行力',
        209: '激励与保留人才',
        210: '领导虚拟团队',
        308: '决策',
        211: '培养人才',
        212: '推动创新',
        304: '协作',
        318: '决策',
        303: '授权',
        204: '打造高效团队'
      }[learningPathMetaId] || '影响力';
  }

  //第一次完成后调用
  setOnceIno(onceValue){
    return this.apiService.ajax({
      'type': 'POST',
      'url': '/sr/onceino/' + onceValue,
    });
  }

  //返回协议origin
  getOrigin(){
    return this.platformLocation['location']['origin'].indexOf('localhost') === -1 ? this.platformLocation['location']['origin'] : 'http://m-uat.transtalent.cn';
  }

  //获取用户自定义锁能力时间
  getCustomLockDate(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/learningpathes/' + learningPathMetaId,
    }).toPromise();
  }

  //添加用户自定义锁能力标识
  setCustomLockDate(learningPath, date){
    for (let i = 0, len = learningPath.subItems.length; i < len; i += 1){
      learningPath.subItems[i].isLock = learningPath.subItems[i].openAt ? new Date(Date.parse(learningPath.subItems[i].openAt)).getTime() > new Date(Date.parse(date)).getTime()  : false;
    }
  }

  //获取cookie的值
  getCookie(str: string): any {
    let arr, reg = new RegExp('(^| )' + str + '=([^;]*)(;|$)');
    if (arr === document.cookie.match(reg)) {
      return unescapeIdentifier(arr[2]);
    } else {
      return null;
    }
  }

  /**
   * 储存localstorage
   * @param key
   * @param value
   */
  setStorage(key: string, value: string): void {
    if (this.checkLocalStorageSupported()) {
      if (!key) return;
      if (typeof value !== 'string') {
        value = JSON.stringify(value);
      }
      window.localStorage.setItem(key, value);
    } else {
      const d = new Date();
      d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)); //设置1周保存期
      const expires = `expires=${d.toUTCString()}`;
      document.cookie = `${key}=${value}; ${expires}`;
    }
  }

  /**
   * 获取localStorage
   * @param key
   */
  getStorage(key: string): string {
    let result = null;
    if (this.checkLocalStorageSupported()) {
      if (!key) return;
      result = window.localStorage.getItem(key);
    } else {
      result = this.getCookie(key);
    }
    return result;
  }


  /**
   * 删除localStorage
   * @param key
   */
  removeStorage(key: string): void {
    if (this.checkLocalStorageSupported()) {
      if (!key) return;
      window.localStorage.removeItem(key);
    } else {
      const d = new Date();
      d.setTime(d.getTime() - 1); //立即过期
      const expires = `expires=${d.toUTCString()}`;
      document.cookie = `${key}=; ${expires}`;
    }
  }

  /**
   * 检查当前页面是否是腾讯模块页面
   * 通过检查URL参数中是否包含moduleId来判断
   * 如果包含moduleId，表示当前页面是腾讯模块页面，返回true
   * 如果不包含moduleId，但sessionStorage中有txModuleId，则将moduleId拼接到当前URL后并返回true
   * 如果既没有moduleId也没有txModuleId，返回false
   *
   * @returns {boolean} 如果是腾讯模块页面返回true，否则返回false
   */
  checkAndSetModuleId() {
    // 获取当前页面的完整 URL
    const urlParams = new URLSearchParams(window.location.search);
    // 获取 moduleId 的值
    const moduleId = urlParams.get('moduleId');
    // 从 sessionStorage 中获取 txModuleId
    const sessionModuleId = window.sessionStorage.getItem('txModuleId');
    // 如果路由中没有 moduleId
    if (!moduleId) {
      console.warn('当前路由里没有获取到moduleId');
      // 如果 sessionStorage 中有 txModuleId
      if (sessionModuleId) {
        console.log('从 sessionStorage 中获取到 txModuleId:', sessionModuleId);
        // 将 moduleId 拼接到当前 URL 后
        const currentUrl = window.location.href;
        const separator = currentUrl.includes('?') ? '&' : '?'; // 判断是否已经有查询参数
        const newUrl = `${currentUrl}${separator}moduleId=${sessionModuleId}`;
        // 更新浏览器地址栏的 URL（不刷新页面）
        window.history.replaceState({}, '', newUrl);
        // 返回 true 表示当前页面是腾讯模块页面
        return true;
      }
      // 如果 sessionStorage 中也没有 txModuleId，清除 sessionStorage 并返回 false
      window.sessionStorage.removeItem('txModuleId');
      return false;
    }
    // 如果路由中有 moduleId，存储到 sessionStorage 中
    window.sessionStorage.setItem('txModuleId', moduleId);
    console.log(moduleId, '🍔🍔🍔🍔🍔🍔🍔🍔🍔🍔');
    // 返回 true 表示当前页面是腾讯模块页面
    return true;
  }


  /**
   * 确认当前环境支不支持localstorage
   */
  checkLocalStorageSupported(): boolean {
    return navigator.cookieEnabled && typeof window.localStorage !== 'undefined';
  }

  /**
   * 根据条件在数组中获取下标
   * @param Lists: any       需要查找下标的数组
   * @param condition :any   查找的条件（key）
   * @param value: any       查找的匹配值 （value）
   */
  getIndexByConditionIdInLists(Lists, condition, value) {
    return (Lists || []).findIndex((v) => v[condition] === value);
  }

  /**
   *校验用户是否有小工具权限
   */
  getUserHaveToolsAPI(): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/sr/tools/yyToolsLibrary/haveToolsAuthority'
    }).toPromise();
  }

  /**
   *校验用户权限：学习中心、工具、教练服务、AI导师
   */
  getUserCheckAuthority(): Promise<any> {
    return this.apiService.ajax({
      'type': 'GET',
      'url': '/ddilearner/v1/checkAuthority'
    }).toPromise();
  }

  hasLeaderCoachAuthority(userAuthority: any): boolean {
    return !!(userAuthority && userAuthority.coachAuthority);
  }

  hasLearningCenterAuthority(userAuthority: any): boolean {
    return !!(userAuthority && userAuthority.learningCenterAuthority);
  }

  hasToolsAuthority(userAuthority: any): boolean {
    return !!(userAuthority && userAuthority.toolsAuthority);
  }

  canEnterLeaderCoach(userAuthority: any): boolean {
    return this.hasLeaderCoachAuthority(userAuthority);
  }

  getLeaderCoachOrigin(): string {
    const location = this.platformLocation['location'];
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      return `${location.protocol}//localhost:3000`;
    }
    return location.origin;
  }

  getLeaderCoachUrl(userAuthority: any): string {
    const token = localStorage.getItem('transtalen-token') || '';
    let url = `${this.getLeaderCoachOrigin()}/leadershipcoach/#/m/login?token=${encodeURIComponent(token)}`;
    if (userAuthority && userAuthority.coachExpired) {
      url += '&coachExpired=true';
    }
    return url;
  }

  appendTokenToUrl(url: string): string {
    const token = localStorage.getItem('transtalen-token');
    if (!token || url.indexOf('token=') !== -1) {
      return url;
    }
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    return `${url}${separator}token=${encodeURIComponent(token)}`;
  }

  /**
   * ajax 建议封装
   * @param opts: Object  ajax's options
   */
  enclosureHttps(opts): Promise<any> {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: opts['method'] || 'GET',
        url: opts['url'],
        data: opts['data'] || {},
        cache: opts['cache'] || false,
        processData: opts['processData'] || false,
        contentType: opts['contentType'] || false,
        dataType: opts['dataType'] || 'json',
        headers : {
          'transtalen-token' : localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '',
          'transtalenuserid' : localStorage.getItem('transtalenuserid') ? localStorage.getItem('transtalenuserid') : ''
        },
        success: res => {
          resolve(res);
        },
        error: err => {
          reject(err);
        }
      });
    });
  }

  xorEncrypt(text, key) {
    // 生成更长的密钥
    let longKey = key;
    while (longKey.length < text.length) {
      longKey += key;
    }

    // XOR加密
    let result = '';
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i) ^ longKey.charCodeAt(i);
      result += String.fromCharCode(charCode);
    }

    // 转换为Base64并反转字符串增加混淆
    return btoa(result).split('').reverse().join('');
  }

  xorDecrypt(encrypted, key) {
    // 反转并解码Base64
    const reversed = encrypted.split('').reverse().join('');
    const decoded = atob(reversed);

    // 生成更长的密钥
    let longKey = key;
    while (longKey.length < decoded.length) {
      longKey += key;
    }

    // XOR解密
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
      const charCode = decoded.charCodeAt(i) ^ longKey.charCodeAt(i);
      result += String.fromCharCode(charCode);
    }

    return result;
  }

  /**
   * 固化登录账号/密码，禁止被 login 响应或 userinfo.name 回写。
   * 多公司切换再 login 只读这两项。
   */
  persistLoginCredentials(account: string, password: string, loginType?: number | string): void {
    if (account) {
      this.setStorage('loginAccount', account);
    }
    this.setStorage('loginPassword', this.xorEncrypt(password || '', this.xorKey));
    if (loginType !== undefined && loginType !== null && loginType !== '') {
      this.setStorage('loginType', String(loginType));
    }
  }

  isPasswordLogin(): boolean {
    const storedType = Number(this.getStorage('loginType') || 0);
    if (storedType === 1) {
      return true;
    }
    if (storedType === 2) {
      return false;
    }
    try {
      const loginData = JSON.parse(this.getStorage('loginData') || '{}');
      return Number(loginData.type) === 1;
    } catch (e) {
      return false;
    }
  }

  getPersistedLoginAccount(): string {
    return this.getStorage('loginAccount') || '';
  }

  getPersistedLoginPassword(): string {
    const stored = this.getStorage('loginPassword');
    if (!stored) {
      return '';
    }
    return this.xorDecrypt(stored, this.xorKey);
  }

  clearLoginCredentials(): void {
    this.removeStorage('loginAccount');
    this.removeStorage('loginPassword');
    this.removeStorage('loginData');
    this.removeStorage('loginType');
  }

  /**
   * 手机号多公司首次点选：只带短票，不带图、短信、正式 token。
   */
  buildPhoneCompanySelectPayload(companyId?: string | number, selectionToken?: string): any {
    return {
      type: 2,
      companyId: companyId,
      companySelectionToken: selectionToken || ''
    };
  }

  /**
   * 选公司再登录。
   * 手机号首次点选（无正式 token）只发短票；已登录切换把正式 token 放进 body。
   * 账密取固化 key，出站前 encrypt；不回写响应里的空 password。
   */
  buildCompanyReloginPayload(loginData: any, companyId?: string, options?: { switchCompany?: boolean; token?: string }): any {
    const data = Object.assign({}, loginData || {});
    const isPhone = Number(data.type) === 2;
    const isSwitch = !!(options && options.switchCompany);

    if (isPhone && !isSwitch) {
      return this.buildPhoneCompanySelectPayload(companyId, data.companySelectionToken);
    }

    delete data.companyList;
    delete data.companySelectionToken;
    delete data.captchaCode;
    delete data.captchaNamespace;
    delete data.verificationCode;
    const account = this.getPersistedLoginAccount() || data.userName || data.phone || '';
    let password = this.getPersistedLoginPassword();
    if (!password && data.password) {
      password = data.password;
    }
    if (isPhone) {
      data.userName = account;
      data.phone = data.phone || account;
    } else {
      data.userName = this.encrypt(account);
      data.type = data.type || 1;
    }
    data.password = this.encrypt(password || '');
    if (companyId) {
      data.companyId = companyId;
    }
    if (isPhone && companyId && isSwitch) {
      data.token = options.token || '';
    } else {
      delete data.token;
    }
    return data;
  }

  clearCompanySelectionState(): void {
    try {
      const stored = JSON.parse(this.getStorage('loginData') || '{}');
      delete stored.companySelectionToken;
      delete stored.companyList;
      this.setStorage('loginData', JSON.stringify(stored));
    } catch (e) {}
  }

  //版本检查：根据本地缓存的版本信息和服务器的版本信息进行对比
  versionExamine(timestamp){
    const storage_version = localStorage.getItem('versionData');
    if (storage_version){//本地有版本信息则进行对比
      if (Number(timestamp) !== Number(storage_version)){
        localStorage.setItem('versionData', timestamp);
        console.log('强制刷新页面~~');
        location.reload();
      }
    }else{//没有的话先存下版本信息，再进行刷新页面
      localStorage.setItem('versionData', timestamp);
      console.log('强制刷新页面~~');
      location.reload();
    }
  }

  /**
   * 判断是否鸿蒙系统
   * @returns boolean
   */
  isHarmonyOS(): boolean {
    const sUserAgent = navigator.userAgent.toLowerCase();
    return sUserAgent.indexOf('harmonyos') !== -1 || sUserAgent.indexOf('harmony') !== -1;
  }

  /**
   * 从URL中提取target_url并添加token
   * @param fullUrl - 包含target_url参数的完整URL
   * @param token - 需要添加的token
   * @returns 添加token后的URL，或null（如果提取失败）
   */
  extractTargetUrlAndAddToken(
    fullUrl: string,
    token: string
  ): string | null {
    try {
      // 1. 解析原始 URL，提取 target_url
      const queryStart = fullUrl.indexOf('?');
      if (queryStart === -1) return null;

      const queryString = fullUrl.substring(queryStart + 1);
      const searchParams = new URLSearchParams(queryString);
      const targetUrlEncoded = searchParams.get('target_url');
      if (!targetUrlEncoded) return null;

      // 2. 解码 target_url
      const targetUrl = decodeURIComponent(targetUrlEncoded);

      // 3. 检查是否存在 #（哈希部分）
      const hashIndex = targetUrl.indexOf('#');
      let baseUrl: string;
      let hashAndQuery: string;

      if (hashIndex !== -1) {
        // 如果存在 #，则分割成 baseUrl 和 hashAndQuery
        baseUrl = targetUrl.substring(0, hashIndex);
        hashAndQuery = targetUrl.substring(hashIndex);
      } else {
        // 如果不存在 #，则整个 URL 作为 baseUrl，hashAndQuery 为空
        baseUrl = targetUrl;
        hashAndQuery = '';
      }

      // 4. 在 hashAndQuery 部分添加 token
      let newHashAndQuery = hashAndQuery;

      if (newHashAndQuery.includes('?')) {
        // 如果已经有查询参数，则用 & 连接 token
        newHashAndQuery += `&token=${encodeURIComponent(token)}`;
      } else {
        // 如果没有查询参数，则用 ? 连接 token
        newHashAndQuery += `?token=${encodeURIComponent(token)}`;
      }

      // 5. 拼接最终 URL
      const finalUrl = baseUrl + newHashAndQuery;
      return finalUrl;
    } catch (e) {
      console.error('Error parsing URL:', e);
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common.service.ts